import {
  IMemberClient,
  IMemberClientRequirementResponse
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/eligibilityRequirement";
import { useLocalStorageState } from "../../hooks/useLocalStorage";
import { useUserId } from "../../query/hooks/helpers";

export const useIsOnlyOneBusinessOwner = () => {
  const userId = useUserId();

  return useLocalStorageState(
    `wingspan(${userId}):is-only-one-business-owner`,
    true
  );
};

export const getHasEligibilityRequirements = (memberClients: IMemberClient[]) =>
  memberClients.some(
    memberClient => !!memberClient.eligibilityRequirements?.length
  );

export const getHasPendingEligibilityRequirements = (
  memberClients: IMemberClient[]
) =>
  memberClients.some(memberClient =>
    memberClient.eligibilityRequirements?.some(
      eligibilityRequirement =>
        eligibilityRequirement.status !== RequirementStatus.Complete
    )
  );

export const getEligibilityRequirements = (memberClients: IMemberClient[]) =>
  memberClients.reduce(
    (result, memberClient) => [
      ...result,
      ...(memberClient.eligibilityRequirements || [])
    ],
    [] as Array<IMemberClientRequirementResponse>
  );
